import { LogicalFieldMixin } from './mixins.js';
import { OptionableMixin } from './optionable.js';

const LogicalRadioButton = {
  mixins: [LogicalFieldMixin, OptionableMixin],

  created: function() {
    this.optionIcon = 'slp-circle-o';
  }
};

export default LogicalRadioButton;
